import React from "react";
import './Detail.css';

export const Detail = () => {
    return (
        <>
            <p className="text-detail">
                Es una libreria de Javascript<br/>
                Funciona basado en un elemento conocido como el virtual DOM<br/>
                Renderiza solamente los componentes que necesita, lo que hace que sea más versátil<br/>
                La utilización de los hooks facilita su lógica frontend
            </p>
        </>
    )
}
